import React, { useEffect } from 'react';
import { Spinner } from '../../../../common';
import DissertationForm from './DissertationForm.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import {
  useGetDissertationDetailQuery,
  useSaveDissertationMutation,
} from '../../../../../redux/services/dissertations';
import { useGetStudyProgramsPhdAllQuery } from '../../../../../redux/services/study_programs';
import { Form as AntdForm } from 'antd';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';

const DissertationsEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = AntdForm.useForm();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  useEffect(() => {
    document.title = isEdit
      ? t('Úprava dizertačnej práce') + ' - FRI CMS'
      : t('Pridanie dizertačnej práce') + ' - FRI CMS';
  }, []); // Runs on mount

  const { saveSuccess } = useToastMessages();

  const { data: studyPrograms, isLoading: isLoadingStudyPrograms } =
    useGetStudyProgramsPhdAllQuery();

  const [saveDissertation, { isSuccess: isSaveSuccess }] =
    useSaveDissertationMutation();

  const { data: dissertationDetail, isLoading: isLoadingDissertation } =
    useGetDissertationDetailQuery(id, { skip: !isEdit });

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      navigate(routes.cmsDissertation);
    }
  }, [isSaveSuccess]);

  const dissertationTitle =
    (isCreate && t('Pridanie dizertačnej práce')) ||
    t('Úprava dizertačnej práce');

  if ((isEdit && isLoadingDissertation) || isLoadingStudyPrograms) {
    return <Spinner />;
  }

  const initials = {
    title: undefined,
    student: undefined,
    supervisor: undefined,
    study_program_id: undefined,
    reviewer1: undefined,
    reviewer2: undefined,
    reviewer3: undefined,
    abstract_sk: undefined,
    abstract_en: undefined,
    ...dissertationDetail,
    summary_file:
      dissertationDetail && dissertationDetail.summary_file
        ? `/storage/phd/${dissertationDetail.id}s-${dissertationDetail.summary_file}` // in this format file name is saved :(
        : null,
    fulltext_file:
      dissertationDetail && dissertationDetail.fulltext_file
        ? `/storage/phd/${dissertationDetail.id}f-${dissertationDetail.fulltext_file}`
        : null,
    year: dissertationDetail
      ? dayjs(new Date(dissertationDetail.year))
      : dayjs(),
  };

  return (
    <>
      <AppBarCMS
        title={dissertationTitle}
        backUrl={routes.cmsDissertation}
        backUrlTooltip={t('Dizertačné práce')}
      />
      <div style={{ margin: '10px' }}>
        <DissertationForm
          form={form}
          allStudyPrograms={studyPrograms}
          studyPrograms={studyPrograms}
          initials={initials}
          isCreate={isCreate}
          onSubmit={(values) => {
            if (isCreate) {
              saveDissertation({ body: values });
            } else {
              saveDissertation({
                id: dissertationDetail.id,
                body: values,
              });
            }
          }}
          fullTextFileName={dissertationDetail?.fulltext_file}
          summaryFileName={dissertationDetail?.summary_file}
        />
      </div>
    </>
  );
};

export default DissertationsEdit;
